import {
  addClass,
  removeClass
} from '@/common/dom'
export default {
  install (Vue, options) {
    // input聚焦
    Vue.directive('focus', {
      inserted: (el, binding) => {
        if (binding.modifiers.select) {
          el.select()
        }
        el.focus()
      }
    })

    Vue.directive('edit', {
      inserted: (el, binding, vnode) => {
        console.log(el.value)
      },
      componentUpdated: (el, binding, vnode) => {
        console.log(222, binding)
      }
    })

    Vue.directive('test', {
      inserted: (el, binding, vnode) => {
        console.log(el.value)
      },
      componentUpdated: (el, binding, vnode) => {
        console.log(222, binding)
      }
    })

    Vue.directive('toggle', {
      inserted: (el, binding, vnode) => {
        let $body = el.parentNode.parentNode.nextElementSibling
        vnode.context.clickHandler = () => {
          let height = $body.getBoundingClientRect().height
          if (height) {
            addClass(el, 'toggled-img')
            $body.style.height = `${height}px`
            setTimeout(() => {
              $body.style.height = '0px'
            }, 10)
          } else {
            removeClass(el, 'toggled-img')
            $body.style.height = 'auto'
            height = $body.getBoundingClientRect().height
            $body.style.height = '0'
            setTimeout(() => {
              $body.style.height = `${height}px`
              setTimeout(() => {
                $body.style.height = ''
              }, 300)
            }, 10)
          }
        }
        el.addEventListener('click', vnode.context.clickHandler)
      },
      unbind: (el, binding, vnode) => {
        el.addEventListener('click', vnode.context.clickHandler)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/directive.js